<template>
    <div>
        <internal-header
            :heading="(isEdit)? 'Manage User Details' : 'Create User'"

            :show-button="(isEdit)"
            button-text="Back to overview"
            :button-link="headerButtonClick"

            :second-show-button="(current_tab === 0 || current_tab === 3)"
            second-button-text="save"
            :second-button-link="secondHeaderButtonClick"
            :second-button-loading="saveLoading"
        />

        <div class="tw-flex tw-flex-col">
            <v-tabs vertical v-model="current_tab" active-class="active-tab" slider-size="0" class="tw-gap-4">
                <v-tab class="tw-border-r-4 tw-border-secondary tw-mb-2 tw-pr-2">User Details</v-tab>
                <v-tab :disabled="!isEdit" class="tw-border-r-4 tw-border-secondary tw-mb-2 tw-pr-2">Emails</v-tab>
                <v-tab :disabled="!isEdit" class="tw-border-r-4 tw-border-secondary tw-mb-2 tw-pr-2">Addresses</v-tab>
                <v-tab class="tw-border-r-4 tw-border-secondary tw-mb-2 tw-pr-2">Confidential</v-tab>
                <v-tab :disabled="!isEdit" class="tw-border-r-4 tw-border-secondary tw-pr-2">Phone Number</v-tab>

                <v-tab-item>
                    <members-manage-details
                        ref="manageDetails"
                        :input="input" :constants="constants"
                        :valuelists="valuelists"
                        :is-edit-prop="isEdit"
                        @successful-manage-member-save="reloadInput"
                        @save-loading-change="updateSaveLoading"
                    />
                </v-tab-item>
                <v-tab-item>
                    <members-manage-emails
                        ref="manageEmails"
                        :input="member" :constants="constants"
                        :valuelists="valuelists"
                        :is-edit-prop="isEdit"
                    />
                </v-tab-item>
                <v-tab-item>
                    <members-manage-addresses
                        ref="manageAddresses"
                        :input="member" :constants="constants"
                        :valuelists="valuelists"
                        :is-edit-prop="isEdit"
                    />
                </v-tab-item>
                <v-tab-item>
                    <members-manage-confidential
                        ref="manageConfidential"
                        :input="input" :constants="constants"
                        :valuelists="valuelists"
                        :is-edit-prop="isEdit"
                        @successful-manage-member-save="reloadInput"
                        @save-loading-change="updateSaveLoading"
                    />
                </v-tab-item>
                <v-tab-item>
                    <members-manage-phones
                        ref="managePhones"
                        :input="member" :constants="constants"
                        :valuelists="valuelists"
                        :is-edit-prop="isEdit"
                    />
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader";
    import MembersManageDetails from "@/Pages/InternalPages/Members/MembersManageDetails";
    import MembersManageEmails from "@/Pages/InternalPages/Members/MembersManageEmails";
    import MembersManageConfidential from "@/Pages/InternalPages/Members/MembersManageConfidential";
    import MembersManagePhones from "@/Pages/InternalPages/Members/MembersManagePhones";
    import MembersManageAddresses from "@/Pages/InternalPages/Members/MembersManageAddresses";

    export default {
        name: "MembersManage",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            SmartTable,
            InternalHeader,
            MembersManageDetails,
            MembersManageEmails,
            MembersManageConfidential,
            MembersManagePhones,
            MembersManageAddresses,
        },
        // remember: {
        //     data: [
        //         'items'
        //     ]
        // },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return {}
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'isEditProp': {
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            }
        },
        data() {
            return {
                member: this.input,
                isEdit: this.isEditProp,
                current_tab: null,
                saveLoading: null,
            }
        },
        methods: {
            headerButtonClick() {
                this.$inertia.visit( route('members.show', this.input.id) )
            },
            secondHeaderButtonClick() {
                switch (this.current_tab) {
                    case 0:
                        this.$refs.manageDetails.saveDetails()
                        break;
                    case 3:
                        this.$refs.manageConfidential.saveConfidential()
                        break;
                }

            },
            reloadInput() {
                this.$inertia.reload({only: ['input']})
            },
            updateSaveLoading(value) {
                this.saveLoading = value
            }

        }
    }
</script>

<style scoped>
.active-tab {
    background-color: #ece4df;
    color: #3c47d1 !important;
    font-weight: bold;
}

.v-tab {
    text-transform: none;
    justify-content: start;
    font-size: 16px;
    letter-spacing: normal;
    height: 35px;
}
</style>
